/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { Noun, Verb, trackUe } from '@trello/analytics';
import MemberAvatar from 'app/gamma/src/components/member-avatar';
import { MemberMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
import { getMe, hasGold } from 'app/gamma/src/selectors/members';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';
import { MemberModel } from 'app/gamma/src/types';
import HeaderButton from './button';
import styles from './header.less';
import classNames from 'classnames';

const HeaderMemberMenuPromise = import(/* webpackChunkName: "member-menu-popover" */ 'app/gamma/src/components/popovers/header-member-menu');
const HeaderMemberMenu = lazy(() => HeaderMemberMenuPromise);

interface Props {
  hasMemberData: boolean;
  hasCrown: boolean;
  isActive: boolean;
  member: MemberModel | undefined;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

class HeaderMemberMenuButtonContainer extends React.Component<Props> {
  memberMenuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const {
      hasCrown,
      hasMemberData,
      isActive,
      member,
      onClick,
    }: Props = this.props;
    const { name = '', username = '' } = member || {};
    const userTitle = `${name}${username && ` (${username})`}`;

    return (
      <>
        <HeaderButton
          // this className is needed by Desktop for the My Cards MenuItem
          className={classNames(
            'js-open-header-member-menu',
            styles.memberButton,
          )}
          onClick={onClick}
          ref={this.memberMenuButtonRef}
          testId={HeaderTestIds.MemberMenuButton}
          title={userTitle}
        >
          <MemberAvatar gold={hasCrown} member={member} size={32} />
        </HeaderButton>
        {hasMemberData &&
          isActive && (
            <Suspense fallback={null}>
              <HeaderMemberMenu
                target={() => this.memberMenuButtonRef.current}
              />
            </Suspense>
          )}
      </>
    );
  }
}

const mapStateToProps = (state: State, ownProps: object) => {
  return {
    hasMemberData: !!getMe(state),
    isActive: isPopoverShown(state, MemberMenuPopoverId),
    hasCrown: hasGold(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<object>, ownProps: object) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.MEMBER_MENU,
        method: 'by using member menu button in header',
      });
      dispatch(showPopover({ name: MemberMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderMemberMenuButtonContainer);
